// eslint-disable-next-line import/no-cycle
import store from '@client/store';
import {Logger, Category} from '@simpleinvest/front-end-logger';
import {ErrorRouteNames} from '@client/routes/errors';
import {Route, NavigationGuardNext} from 'vue-router';
import {ClientWindow} from '@client/custom-window';

declare let window: ClientWindow;

const logger = new Logger({
  category: Category.PrivateLabel,
  fileName: 'loadLayout.js',
});

// TODO: Refactor this so we don't have to
const loadLayout = async (to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
  if (!store.state.isLayoutSet && to.name !== ErrorRouteNames.NotFoundPage) {
    try {
      await store.dispatch('getLayout', to.name);
    } catch {
      logger.addBreadcrumb({
        callingFuncName: 'loadLayout',
        message: `Failed to load riaId/riaSettings for ${window.BASE_URL}.`,
      });

      // eslint-disable-next-line callback-return
      next({name: ErrorRouteNames.NotFoundPage});
    }
  }

  next();
};

export default loadLayout;
